// extracted by mini-css-extract-plugin
export default {"removeButton":"removeButton--_yUaT"};